module.exports = __webpack_public_path__ + "static/stone-fbdd558c09273fa5ab29a9ba148e2c09.jpg";